import { UmbracoTypes } from '~/lib/data-contract';
import { usePopularResults } from '~/services/loop54/hooks';
import { memo } from 'react';
import { CarouselWithItems } from './helpers';

function M30PopularProductCarousel({
    headline,
    link,
    onlyShowInStock,
}: Omit<UmbracoTypes.IM30PopularProductCarouselModule, 'type'>) {
    const { data } = usePopularResults({ onlyShowInStock });

    return <CarouselWithItems data={data?.results?.items} headline={headline} link={link} />;
}

export default memo(M30PopularProductCarousel);
